// © Microsoft Corporation. All rights reserved.
/**
 * Browser version operators enum
 */
export var BrowserVersionOperator;
(function (BrowserVersionOperator) {
    BrowserVersionOperator["Equals"] = "equals";
    BrowserVersionOperator["GreaterThan"] = "greaterThan";
    BrowserVersionOperator["LessThan"] = "lessThan";
    BrowserVersionOperator["NotEquals"] = "notEquals";
    BrowserVersionOperator["OneOf"] = "oneOf";
})(BrowserVersionOperator || (BrowserVersionOperator = {}));
//# sourceMappingURL=BrowserVersionOperator.js.map